import React, {useState, useEffect, useContext} from "react";
import DashboardWidget from "./DashboardWidget";
import axios from "../common/axios";
import ListItemMessage from "../common/ListItemMessage";
import ShortcutLink from "../common/ShortcutLink";
import {UserContext} from "../common/UserContext";
import useCurrentShortcut from "../hooks/useCurrentShortcut";
import Button from "../common/Button";
import GoToButtonSection from "../components/GoToButtonSection";
import {BrandContext} from "../common/BrandContext";

const MessageDashboardWidget = props => {
    const {...other} = props;
    const [messages, setMessages] = useState([]);
    const [isLoading, setLoading] = useState(true);
    const {user, setUser} = useContext(UserContext);
    const {loadShortcutByUrl} = useCurrentShortcut();
    const brandConfig = useContext(BrandContext);

    useEffect(() => {
        setLoading(true);
        axios.get('/web/ui/message/userMessages',  { params: {page: 1 } })
            .then(response => {
                setMessages(response.data);
                setLoading(false);
            });
    }, []);

    const handleMessageOnClick = (messageId, messageUnRead) => {
        globalReactFunctions.messageId = messageId;
        globalReactFunctions.messageUnRead = messageUnRead;
        loadShortcutByUrl('/web/ui/view/messages');
    }

    return (
        <>
            {brandConfig.use2025Dashboard &&
                <h2>My messages</h2>
            }
            <DashboardWidget
                title={!brandConfig.use2025Dashboard &&
                    <div className="ch-dashboard-title-with-icon">
                        <svg className="ch-icon-medium" viewBox="0 0 128 128">
                            <use href="#messages-icon"></use>
                        </svg>
                        <span>Messages</span>
                    </div>
                }
                isLoading={isLoading}
                {...other}>
                <div className={'ch-dashboard-blk-body'}>
                    {messages.length > 0 &&
                        <table className={'ch-dashboard-widget-table ch-table'}>
                            <thead>
                                <tr>
                                    <th>Subject</th>
                                    <th>Sent</th>
                                    <th>Expires</th>
                                    <th>From</th>
                                </tr>
                            </thead>
                            <tbody>
                            {messages.map((message, index) => (
                                <ListItemMessage key={message.messageId} message={message} onClick={()=>{handleMessageOnClick(message.messageId, !message.read)}} />
                            ))}
                            </tbody>
                        </table>
                    }
                    {messages.length == 0 &&
                        <div className="ch-list-item-disabled">No messages available</div>
                    }
                </div>
                <GoToButtonSection buttonText={'Go to all messages'} onClick={() => loadShortcutByUrl('/web/ui/view/messages')} />
            </DashboardWidget>
        </>
    )
}

export default MessageDashboardWidget;